<template>
  <div v-visibility-change="visibilityChange">
    <div class="resultsPatsnt">
      <div class="title_resultsPatsnt">
        <div class="title_resultsPatsnt_text">
          {{ $t("message.patient_report") }}
        </div>
      </div>

      <div class="itme_resultsPatsnt" v-if="list.length != 0">
        <table class="table mt-4" v-loading="loadingData">
          <thead>
            <tr>
              <th>#</th>
              <th>{{ $t("message.services") }}</th>

              <th>{{ $t("message.date") }}</th>
              <th>{{ $t("message.settings") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(ser, index) in list"
              :key="'order-create-in-header' + index"
            >
              <td>{{ index + 1 }}</td>
              <td>
                {{ ser.service.name }}
              </td>
              <td>
                {{ ser.created_at }}
              </td>
              <td class="we10">
                <div class="d-flex">
<!--                  <el-button-->
<!--                    v-if="ser.conclusion_count"-->
<!--                    icon="el-icon-edit"-->
<!--                    @click="edit(ser)"-->
<!--                    type="primary"-->
<!--                    round-->
<!--                    >{{ $t("message.update") }}</el-button-->
<!--                  >-->
                  <el-button
                    v-if="ser.conclusion_count"
                    icon="el-icon-view"
                    @click="show(ser)"
                    type="primary"
                    round
                    >{{ $t("message.show_0") }}</el-button
                  >
<!--                  <el-button-->
<!--                    v-if="!ser.conclusion_count"-->
<!--                    @click="documentOpen(ser.service_id)"-->
<!--                    icon="el-icon-edit"-->
<!--                    type="success"-->
<!--                    round-->
<!--                    >{{ $t("message.write_conclusions") }}</el-button-->
<!--                  >-->
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <el-drawer
          size="55%" :wrapperClosable="false"
          :visible.sync="drawer.update.status"
          :with-header="false"
          :ref="drawer.update.name"
          :before-close="beforeClose"
          @opened="drawerOpened(drawer.update.component)"
          @closed="drawerClosed(drawer.update.component)"
        >
          <crm-update
            :drawer-name="drawer.update.name"
            :ref="drawer.update.component"
            :selected="selectedModel"
          />
        </el-drawer>

        <el-drawer
          title="Показать заключение"
          :visible.sync="drawerShow"
          size="70%" :wrapperClosable="false"
          :drawer="drawerShow"
          @open="reopenShow = true"
          @close="reopenShow = false"
          @closed="emptyModel"
        >
          <div>
            <crm-show
              :reloadModel="reopenShow"
              @open="reopenShow = true"
              @c-close="reloadIfChanged('drawerShow')"
              @closed="emptyModel"
            ></crm-show>
          </div>
        </el-drawer>
      </div>
    </div>

    <el-dialog
      :title="$t(`message.choose_template`)"
      :append-to-body="true"
      :visible.sync="outerVisible"
      width="40%"
    >
      <el-row :gutter="20">
        <el-col :span="24">
          <el-input
            clearable
            :placeholder="$t('message.search_template')"
            v-model="filterText"
          ></el-input>
          <el-tree
            class="mt-2 filter-tree"
            :data="data"
            node-key="id"
            :filter-node-method="filterNode"
            ref="tree"
            @node-click="handleNodeClick"
            :expand-on-click-node="false"
            show-checkbox
          >
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <span class="maxWidht ss">
                {{ data.name }}
              </span>
            </span>
          </el-tree>
        </el-col>
      </el-row>

      <div slot="footer" class="dialog-footer">
        <el-button @click="createConclusion()" type="success">
          {{ $t("message.create") }}
        </el-button>
        <el-button @click="dialogClose()"> {{$t('message.close')}} </el-button>
      </div>
    </el-dialog>

    <el-drawer
      size="90%" :wrapperClosable="false"
      :visible.sync="drawer.create.status"
      :ref="drawer.create.name"
      :before-close="beforeClose"
      @opened="drawerOpened(drawer.create.component)"
      @closed="drawerClosed(drawer.create.component)"
    >
      <crm-create
        :ref="drawer.create.component"
        :drawer-name="drawer.create.name"
      ></crm-create>
    </el-drawer>

    <el-drawer :visible.sync="drawer2" size="70%" :wrapperClosable="false" :with-header="false">
      <PatientConclusionFind />
    </el-drawer>
  </div>
</template>
<script>
import CrmCreate from "./components/patientConclusionCreate";
import PatientConclusionFind from "./components/patientConclusionFind";
import CrmUpdate from "./components/patientConclusionUpdate";
import CrmShow from "./components/patientConclusionShow";
import list from "@/utils/mixins/list";
import { i18n } from "@/utils/i18n";

import drawer from "@/utils/mixins/drawer";
import { mapGetters, mapActions } from "vuex";
export default {
  mixins: [drawer, list],
  name: "patientConclusion",
  data() {
    return {
      outerVisible: false,
      form: [],
      drawerUpdate: false,
      drawerShow: false,
      drawer2: false,
      loadingData: false,
      isItemsModelVisible: false,
      isLoadingItems: false,
      selectedModel: null,
      backUrl: process.env.VUE_APP_URL_DOCS,
      reopenUpdate: false,
      reopenShow: false,
      filterText: "",
      excel_data: [],
      service_id: null,
      data: null,
      excel_fields: {},
      drawer: {
        create: {
          name: "create",
          component: "componentCreate",
          status: false,
        },
        update: {
          name: "update",
          component: "componentUpdate",
          status: false,
        },
      },
    };
  },
  components: {
    CrmUpdate,
    CrmShow,
    CrmCreate,
    PatientConclusionFind,
  },
  computed: {
    ...mapGetters({
      current_user_id: "hospitalizationConclusions/current_user_id",
      list: "hospitalizationConclusions/list",
      columns: "hospitalizationConclusions/columns",
      pagination: "hospitalizationConclusions/pagination",
      filter: "hospitalizationConclusions/filter",
      sort: "hospitalizationConclusions/sort",
      states: "states/list",
      token: "auth/token",
      model: "orders/relation_model",
      user_id: "auth/id",
      activeCode: "patients/activeCode",
      lastHistory: "patientHistories/model",
    }),
    getId() {
      return this.$route.params.id;
    },
    actions: function () {
      return ["edit", "delete"];
    },
  },
  async created() {},
  watch: {
    columns: {
      handler: function () {},
      deep: true,
    },
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    lastHistory: {
      handler: function (val, oldVal) {
        this.showModels({
          patient_id: val.patient_id,
          id: this.getId,
        })
          .then((res) => {})
          .catch((err) => {
            this.$notify({
              title: 'Ошибка',
              type: "error",
              offset: 130,
              message: err.error.message
            });
          });
      },
    },
  },
  async mounted() {
    if (this.lastHistory.id === "") {
      this.getLastHistory({id: this.getId});
    }
  },
  methods: {
    ...mapActions({
      categoryDocumentationList: "categoryDocumentation/index",
      editServiceModel: "hospitalizationServices/indexitems",
      updateList: "hospitalizationServices/index",
      updateSort: "hospitalizationConclusions/updateSort",
      updateFilter: "hospitalizationConclusions/updateFilter",
      updateColumn: "hospitalizationConclusions/updateColumn",
      updatePagination: "hospitalizationConclusions/updatePagination",
      showModel: "hospitalizationConclusions/show",
      showModels: "hospitalizationConclusions/indexitems",
      editModel: "hospitalizationConclusions/show",
      empty: "hospitalizationConclusions/empty",
      delete: "hospitalizationConclusions/destroy",
      refreshData: "hospitalizationConclusions/refreshData",
      getLastHistory: "patientHistories/show",
    }),
    fetchData() {
      this.loadingData = true;
      var vm = this;
      this.categoryDocumentationList({ relation: true })
        .then((res) => {
          this.data = res.data.category_forms;
        })
        .catch((err) => {
          console.log(err);
        });
      this.showModels({
        id: this.getId,
      })
        .then((res) => {
          this.loadingData = false;
        })
        .catch((err) => {
          this.loadingData = false;
          this.$notify({
            title: 'Ошибка',
            type: "error",
            offset: 130,
            message: err.error.message
          });
        });
      this.editServiceModel({
        patient_id: vm.getId,
        id: this.lastHistory.id,
      })
        .then((res) => {
          this.loadingData = false;
        })
        .catch((err) => {
          this.loadingData = false;
          this.$notify({
            title: 'Ошибка',
            type: "error",
            offset: 130,
            message: err.error.message
          });
        });
    },
    visibilityChange(evt, hidden) {
      if (!hidden) this.fetchData();
    },
    refresh() {
      this.refreshData()
        .then((res) => {
          this.filterForm = JSON.parse(JSON.stringify(this.filter));
        })
        .catch((err) => {});
    },
    destroy(model) {
      this.$confirm(i18n.t("message.do_you_want"), i18n.t("message.warning"), {
        confirmButtonText: i18n.t("message.yes"),
        cancelButtonText: i18n.t("message.cancel"),
        type: "warning",
      })
        .then(() => {
          this.$loadingCursor("wait");
          this.delete(model.id)
            .then((res) => {
              this.$notify({
            title: 'Успешно',
            type: "success",
            offset: 130,
            message: res.message
          });
              this.$loadingCursor("default");
            })
            .catch((err) => {
              this.$loadingCursor("default");
              console.log(err);
            });
        })
        .catch(() => {
          this.$message({
            type: "warning",
            message: i18n.t("message.cancel"),
          });
        });
    },
    documentOpen(id) {
      this.service_id = id;
      this.outerVisible = true;
      // this.drawer.create.status = true;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    handleNodeClick(node, data, value) {},
    createConclusion() {
      let item = this.$refs.tree.getCheckedNodes();
      let template_id = null;
      for (const i in item) {
        if (item[i]) {
          const element = item[i];
          if (element.children.length == 0 && element.category_id) {
            template_id = element.id;
          }
        }
      }

      this.createModal(this.service_id, template_id);
    },

    async show(model) {
      var link = document.createElement("a");
      link.setAttribute(
        "href",
        this.backUrl +
          "/file_orientation_patient_room?fileName=" +
          model.name +
          "&user=" +
          this.token +
          "&status=show" +
          "&patient_id=" +
          this.getId
      );
      link.setAttribute("target", "_blank");
      link.click();
      return;
    },
    async createModal(service_id, template_id) {
      var link = document.createElement("a");
      link.setAttribute(
        "href",
        this.backUrl +
          "/file_orientation_patient_room?template_id=" +
          template_id +
          "&user=" +
          this.token +
          "&status=create" +
          "&service_id=" +
          service_id +
          "&patient_id=" +
          this.getId
      );
      link.setAttribute("target", "_blank");
      link.click();
      this.dialogClose();
      return;
    },
    async edit(model) {
      var link = document.createElement("a");
      link.setAttribute(
        "href",
        this.backUrl +
          "/file_orientation_patient_room?fileName=" +
          model.name +
          "&service_id=" +
          model.service_id +
          "&user=" +
          this.token +
          "&status=edit" +
          "&patient_history_id=" +
          this.getId
      );
      link.setAttribute("target", "_blank");
      link.click();

      return;
    },

    dialogClose() {
      this.$refs.tree.setCheckedNodes([]);
      this.outerVisible = false;
      this.form = {};
      this.model = null;
      this.service_id = null;
    },
    beforeClose(done) {
      this.empty();
      this.refreshData();
      done();
    },
    emptyModel() {
      this.empty();
    },
  },
};
</script>
<style lang="scss" >
.itme_resultsPatsnt {
  padding: 20px;
}
.we10 {
  width: 220px;
  text-align: right;
}
</style>